import MainLayout from '../layouts/main';
import ConsultPackagesListContainer from './container';

function ConsultPackagesPage() {
  return (
    <MainLayout
      consultPackageRequired={false}
      packageRequired={false}
    >
      <ConsultPackagesListContainer/>
    </MainLayout>
  );
}

export default ConsultPackagesPage;

